import React, { useEffect, useState, useCallback } from 'react';

// Lightweight mouse glow - CSS only, throttled updates
const MouseGlow = () => {
  const [position, setPosition] = useState({ x: -200, y: -200 });
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(true);
  
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768 || 'ontouchstart' in window);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  // Throttled mouse move handler
  const handleMouseMove = useCallback((e) => {
    // Use CSS variables for smoother updates
    document.documentElement.style.setProperty('--mouse-x', `${e.clientX}px`);
    document.documentElement.style.setProperty('--mouse-y', `${e.clientY}px`);
    if (!isVisible) setIsVisible(true);
  }, [isVisible]);
  
  useEffect(() => {
    if (isMobile) return;
    
    // Throttle to 30fps for performance
    let lastCall = 0;
    const throttledHandler = (e) => {
      const now = Date.now();
      if (now - lastCall >= 33) { // ~30fps
        lastCall = now;
        handleMouseMove(e);
      }
    };
    
    window.addEventListener('mousemove', throttledHandler, { passive: true });
    document.body.addEventListener('mouseleave', () => setIsVisible(false));
    
    return () => {
      window.removeEventListener('mousemove', throttledHandler);
    };
  }, [isMobile, handleMouseMove]);
  
  if (isMobile) return null;
  
  return (
    <div
      className="fixed pointer-events-none z-[9998] transition-opacity duration-300"
      style={{
        left: 'var(--mouse-x, -200px)',
        top: 'var(--mouse-y, -200px)',
        transform: 'translate(-50%, -50%)',
        opacity: isVisible ? 1 : 0,
        width: '300px',
        height: '300px',
        background: 'radial-gradient(circle, rgba(255,215,0,0.06) 0%, transparent 70%)',
        filter: 'blur(20px)',
        willChange: 'left, top',
      }}
    />
  );
};

export default MouseGlow;
